/* The PDF links remain usable when JavaScript is unavailable. */
function initPromoLibraries(root = document) {
  root.querySelectorAll('.promo-site--industry').forEach((page) => {
    if (page.dataset.libraryReady) return;
    page.dataset.libraryReady = 'true';
    const input = page.querySelector('[data-ps-library-search]');
    const cards = [...page.querySelectorAll('[data-ps-flyer]')];
    if (!input) return;
    page.querySelector('[data-ps-library-tools]').hidden = false;
    const filter = () => {
      const words = input.value.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach((card) => {
        const match = words.every((word) => card.dataset.psFlyer.toLocaleLowerCase().includes(word));
        card.hidden = !match;
        if (match) count++;
      });
      page.querySelector('[data-ps-library-count]').textContent = `${count} industry ${count === 1 ? 'flyer' : 'flyers'}`;
      page.querySelector('[data-ps-library-empty]').hidden = count > 0;
    };
    input.addEventListener('input', filter);
    page.querySelector('[data-ps-library-reset]').addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
  });
}
initPromoLibraries();
document.addEventListener('shopify:section:load', (event) => initPromoLibraries(event.target));
